export const BlackButton = (props) => {
    const {
        children,
        onClick,
        disabled,
        className,
        outlined = false,
        type = 'button',
        text = 'white'
    } = props;

    const getButtonClasses = () => {
        if (!outlined) {
            return `bg-black ${text === 'secondary' ? 'text-secondary hover:text-secondary' : 'text-white hover:text-black'} hover:bg-transparent `
        } else {
            return `bg-transparent text-black hover:bg-black hover:text-white`
        }
    }

    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`rounded-md border border-solid border-black px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out ${getButtonClasses()} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className ?? ''}`}
        >
            {children}
        </button>
    )
}